import { useEffect } from 'react';

// The staff app's index.html carries no mobile viewport: it is a desktop tool.
// Every page a CUSTOMER opens on a phone (booking, manage, pay link, damage
// hold) must switch one on, or the phone draws it at desktop width and shrinks
// it to fit. The damage hold page shipped without it (6 Oct, Manny's phone).
// check-public-viewport.js asserts every customer page calls this.
export default function useMobileViewport() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="viewport"]');
    const created = !meta;
    const previous = meta ? meta.getAttribute('content') : null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'viewport');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
    return () => {
      if (created) meta.remove();
      else if (previous !== null) meta.setAttribute('content', previous);
    };
  }, []);
}
